import { useState, useContext, useEffect, useRef } from "react";
import { Stack, TextField } from "@fluentui/react";
import { SendRegular } from "@fluentui/react-icons";
import Send from "../../../assets/Send.svg";
import styles from "./QuestionInput.module.css";
import Mic from "../../../assets/mic-static.svg";
import Micactive from "../../../assets/mic-static-active.svg";
import MuteMic from "../../../assets/mute.png";
import { AppStateContext } from "../../../state/AppProvider";
import ImpIcon from "../../../assets/import (2).png";
import DriveIcon from "../../../assets/google-drive.png";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import { Menu, MenuItem } from "@mui/material";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { CosmosDBStatus } from "../../../api/models";
import React from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { BackendURL } from "../../../../env";
import { MicButton } from "../../../components/Voice/VoiceModule";
import {
  normalizeVoiceAppKey,
  VOICE_ACCESS_REQUIRED_MESSAGE,
  VOICE_APP_SELECTION_MESSAGE,
} from "../../../utils/voiceApp";
import { isModelVoiceEnabled } from "../../../utils/voiceModel";

interface Props {
  onSend: (question: string, id?: string, fileurl?: URL | any) => void;
  disabled: boolean;
  placeholder?: string;
  clearOnSend?: boolean;
  conversationId?: string;
  FollowUpsProp?: string;
  onNewChat?: () => void;
  voiceStatus: any;
  toggleSession: () => void;
}

export const QuestionInput = ({
  onSend,
  disabled,
  placeholder,
  clearOnSend,
  conversationId,
  FollowUpsProp,
  onNewChat,
  voiceStatus,
  toggleSession,
}: Props) => {
  const [question, setQuestion] = useState<string>("");
  // const [micStatus, setMicStatus] = useState<string>(Mic);
  const [micStatus, setMicStatus] = useState<boolean>(false);
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedFile, setSelectedFile] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [pastedImage, setPastedImage] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isClicked, setIsClicked] = React.useState<boolean>(false);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [showFollowups, setShowFollowups] = useState(true);
  const [modelactive, setModelActive] = useState(false);
  const [voiceAutoSendPending, setVoiceAutoSendPending] = useState(false);
  const [fileValidationError, setFileValidationError] = useState<string>("");
  const silenceTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const {
    listening,
    interimTranscript,
    finalTranscript,
    resetTranscript,
    browserSupportsSpeechRecognition,
  } = useSpeechRecognition();
  const isRealtimeVoiceActive =
    voiceStatus && voiceStatus !== "idle" && voiceStatus !== "error";

  const handleMultimodel = () => {
    setModelActive((prevState) => !prevState);
    //console.log("modelactive",modelactive)
  };

  const appStateContext = useContext(AppStateContext);
  const isPrysmView = ["1", "true"].includes(localStorage.getItem("PrysmView") || "");
  const selectedAppName = appStateContext?.state.selectedApp || "";
  const selectedAIName = appStateContext?.state.selectedAI || "";
  const matchedAppConfig =
    appStateContext?.state.appCategory?.find(
      (app: any) =>
        app?.Name === selectedAppName ||
        app?.Name === selectedAIName ||
        app?.Display_Name === selectedAppName ||
        app?.Display_Name === selectedAIName,
    ) || null;
  const matchedModelConfig =
    appStateContext?.state.modelCategory?.find(
      (model: any) =>
        model?.Name === selectedAIName ||
        model?.Display_Name === selectedAIName,
    ) || null;
  const voiceAppCandidates = isPrysmView
    ? [
        matchedModelConfig?.Name,
        selectedAIName,
        matchedModelConfig?.Display_Name,
        matchedAppConfig?.Name,
        selectedAppName,
        matchedAppConfig?.Display_Name,
      ].filter(Boolean)
    : [
        matchedAppConfig?.Name,
        matchedModelConfig?.Name,
        selectedAppName,
        selectedAIName,
        matchedAppConfig?.Display_Name,
        matchedModelConfig?.Display_Name,
      ].filter(Boolean);
  const selectedVoiceAppKey =
    voiceAppCandidates
      .map((candidate) => normalizeVoiceAppKey(candidate))
      .find(Boolean) || null;
  const isVoiceSupportedForSelectedApp = !!selectedVoiceAppKey;
  const voiceEnabledConfig = matchedModelConfig || matchedAppConfig;
  const isVoiceEnabledForSelectedModel =
    isModelVoiceEnabled(voiceEnabledConfig);
  const isVoiceEnabledForSelectedApp =
    isVoiceSupportedForSelectedApp && isVoiceEnabledForSelectedModel;
  const voiceTooltipText = isVoiceEnabledForSelectedApp
    ? selectedVoiceAppKey === "supportpop"
      ? "Use voice"
      : selectedVoiceAppKey === "lipione" || selectedVoiceAppKey === "jarvisone"
      ? "Use voice"
      : "Use voice"
    : isVoiceSupportedForSelectedApp
    ? VOICE_ACCESS_REQUIRED_MESSAGE
    : VOICE_APP_SELECTION_MESSAGE;

  useEffect(() => {
    appStateContext?.dispatch({
      type: "LIVESEARCh__ACTIVE",
      payload: isClicked,
    });
  }, [isClicked, appStateContext?.dispatch]);

  const handleSearch = () => {
    setIsClicked((prevState) => !prevState);
  };

  useEffect(() => {
    if (FollowUpsProp) {
      const followup = FollowUpsProp;
      setQuestion(followup);

      appStateContext?.dispatch({
        type: "SEND_TRYIT_PROMPT",
        payload: "",
      });

      setTimeout(() => {
        const sendButton = document.querySelector(
          `.${styles.questionInputSendButtonContainer}`,
        ) as HTMLElement;

        if (sendButton) {
          sendButton.click();
        }
      }, 100);
    }
  }, [FollowUpsProp]);

  const sendQuestion = (overrideQuestion?: string) => {
    const questionToSend = (overrideQuestion ?? question).trim();
    if (disabled || (!questionToSend && !selectedFile)) {
      return;
    }

    appStateContext?.dispatch({
      type: "ENTERED_QUESTION",
      payload: questionToSend,
    });

    if (conversationId) {
      onSend(questionToSend, selectedFile, conversationId);
      const regenrateValue = questionToSend;
      appStateContext?.dispatch({
        type: "REGENRATE_VALUE",
        payload: regenrateValue,
      });
    } else {
      onSend(questionToSend, selectedFile);
      const regenrateValue = questionToSend;
      appStateContext?.dispatch({
        type: "REGENRATE_VALUE",
        payload: regenrateValue,
      });
    }

    if (clearOnSend) {
      setQuestion("");
      setSelectedFile(null);
      setPastedImage(null);
      setIsLoading(true);
    }
  };

  const regenrateHandle = () => {
    const storedRegen: any = appStateContext?.state.regenrateValue;
    setQuestion(storedRegen);
  };

  const onEnterPress = (ev: React.KeyboardEvent<Element>) => {
    if (ev.key === "Enter" && !ev.shiftKey) {
      ev.preventDefault();
      sendQuestion();
    }
  };

  useEffect(() => {
    // console.log("Updated followups:", appStateContext?.state.PrivacyFollowups);
  }, [appStateContext?.state.PrivacyFollowups]);

  const tryitVal: any = appStateContext?.state.clearChatHistory;
  useEffect(() => {
    if (tryitVal !== null && tryitVal.trim()) {
      setQuestion(tryitVal);

      const tryitPrompt = "";
      appStateContext?.dispatch({
        type: "SEND_TRYIT_PROMPT",
        payload: tryitPrompt,
      });

      setTimeout(() => {
        const sendButton = document.querySelector(
          `.${styles.questionInputSendButtonContainer}`,
        ) as HTMLElement;

        if (sendButton) {
          sendButton.click();
        }
      }, 100);
    }
  }, [tryitVal]);

  const clearSilenceTimeout = () => {
    if (silenceTimeoutRef.current) {
      clearTimeout(silenceTimeoutRef.current);
      silenceTimeoutRef.current = null;
    }
  };

  const startListening = () => {
    if (isRealtimeVoiceActive) return;

    if (!browserSupportsSpeechRecognition) {
      console.error("Speech recognition not supported in this browser.");
      return;
    }

    if (listening) {
      SpeechRecognition.stopListening();
      clearSilenceTimeout();
      setVoiceAutoSendPending(false);
      return;
    }

    resetTranscript();
    setVoiceAutoSendPending(true);
    setMicStatus(true);

    SpeechRecognition.startListening({
      continuous: false,
      interimResults: true,
      language: navigator.language || "en-US",
    });

    clearSilenceTimeout();
    silenceTimeoutRef.current = setTimeout(() => {
      SpeechRecognition.stopListening();
      setVoiceAutoSendPending(false);
      setMicStatus(false);
    }, 8000);
  };

  const handleRealtimeVoiceClick = () => {
    if (!isVoiceEnabledForSelectedApp) return;
    toggleSession();
  };

  useEffect(() => {
    if (isRealtimeVoiceActive) return;
    if (!voiceAutoSendPending) return;
    const liveTranscript = (interimTranscript || finalTranscript || "").trim();
    if (!liveTranscript) return;

    setQuestion(liveTranscript);
    appStateContext?.dispatch({
      type: "SET_CURRENT_QUESTION",
      payload: liveTranscript,
    });

    clearSilenceTimeout();
    silenceTimeoutRef.current = setTimeout(() => {
      SpeechRecognition.stopListening();
      setVoiceAutoSendPending(false);
      setMicStatus(false);
    }, 8000);
  }, [
    interimTranscript,
    finalTranscript,
    voiceAutoSendPending,
    isRealtimeVoiceActive,
  ]);

  useEffect(() => {
    if (isRealtimeVoiceActive) return;
    if (!voiceAutoSendPending) return;
    const finalText = finalTranscript.trim();
    if (!finalText) return;

    clearSilenceTimeout();
    setVoiceAutoSendPending(false);
    setMicStatus(false);
    sendQuestion(finalText);
    resetTranscript();
    SpeechRecognition.stopListening();
  }, [finalTranscript, voiceAutoSendPending, isRealtimeVoiceActive]);

  useEffect(() => {
    if (!isRealtimeVoiceActive) return;
    clearSilenceTimeout();
    setVoiceAutoSendPending(false);
    setMicStatus(false);
    SpeechRecognition.stopListening();
  }, [isRealtimeVoiceActive]);

  useEffect(() => {
    if (listening) return;
    setMicStatus(false);
    clearSilenceTimeout();
  }, [listening]);

  useEffect(
    () => () => {
      clearSilenceTimeout();
      SpeechRecognition.stopListening();
    },
    [],
  );

  const onQuestionChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    setQuestion(value);
    appStateContext?.dispatch({ type: "SET_CURRENT_QUESTION", payload: value });
  };

  const sendQuestionDisabled =
    disabled || (!question.trim() && !selectedFile && !pastedImage);

  const handleFileSelect = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      const ext = `.${file.name.split(".").pop()?.toLowerCase() || ""}`;
      const mime = (file.type || "").toLowerCase();
      const blocked =
        mime.startsWith("video/") ||
        mime === "application/json" ||
        mime === "image/svg+xml" ||
        ext === ".mp4" ||
        ext === ".json" ||
        ext === ".svg";

      if (blocked) {
        setFileValidationError(
          "Video, JSON, and SVG files are not supported. Please upload PDF, DOC, XLS, TXT, or image files.",
        );
        event.target.value = "";
        handleMenuClose();
        return;
      }

      setFileValidationError("");

      const formData = new FormData();
      formData.append("file", file);
      console.log("formData", formData);

      const Email = localStorage.getItem("Email");
      if (Email) formData.append("Email", Email);

      const selctedAi = appStateContext?.state.selectedAI;
      if (selctedAi) formData.append("selectedAI", selctedAi);

      for (let [key, value] of formData.entries()) {
      }
      handleMenuClose();

      try {
        const response = await fetch(`${BackendURL}/get_pdf_url`, {
          method: "POST",
          body: formData,
        });

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(
            `Error ${response.status}: ${response.statusText}\n${errorText}`,
          );
        }

        const data = await response.json();
        setSelectedFile(data.image_blob_url);
      } catch (error) {
        console.error("Error uploading File:", error);
      }
    }
  };

  // const handleFileSelect = async (
  //   event: React.ChangeEvent<HTMLInputElement>
  // ) => {
  //   if (event.target.files && event.target.files.length > 0) {
  //     const file = event.target.files[0];
  //     handleMenuClose();

  //     const formData = new FormData();
  //     formData.append("file", file);
  //     setLoading(true);

  //     try {
  //       const response = await fetch(`${BackendURL}/get_pdf_url`, {
  //         method: "POST",
  //         body: formData,
  //       });

  //       if (!response.ok) {
  //         const errorText = await response.text();
  //         throw new Error(
  //           `Error ${response.status}: ${response.statusText}\n${errorText}`
  //         );
  //       }

  //       const data = await response.json();
  //       setSelectedFile(data.image_blob_url);
  //     } catch (error: any) {
  //       console.error("Error uploading File:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   } else {
  //     //   console.log("Please select a file to upload.");
  //   }
  // };

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const handleCancelFile = () => {
    setSelectedFile(null);
    setPastedImage(null);
    setFileValidationError("");
  };

  const handlePaste = async (event: ClipboardEvent) => {
    const items = event.clipboardData?.items;
    if (items) {
      for (let i = 0; i < items.length; i++) {
        const item = items[i];

        if (item.type.indexOf("image") !== -1) {
          const blob = item.getAsFile();

          if (blob) {
            const reader = new FileReader();
            reader.onload = async (event: any) => {
              const imageDataUrl = event.target.result;

              setPastedImage(imageDataUrl);

              const formData = new FormData();
              formData.append("file", blob);

              try {
                const Email = localStorage.getItem("Email");
                if (Email) {
                  formData.append("Email", Email);
                }

                const selctedAi = appStateContext?.state.selectedAI;
                if (selctedAi) {
                  formData.append("selectedAI", selctedAi);
                }

                const response = await fetch(`${BackendURL}/get_pdf_url`, {
                  method: "POST",
                  body: formData,
                });

                if (!response.ok) {
                  const errorText = await response.text();
                  throw new Error(
                    `Error ${response.status}: ${response.statusText}\n${errorText}`,
                  );
                }

                const data = await response.json();

                setSelectedFile(data.image_blob_url);
              } catch (error: any) {
                console.error("Error uploading file:", error);
              }
            };

            reader.readAsDataURL(blob);
          }
        }
      }
    }
  };

  useEffect(() => {
    const textArea = document.querySelector("textarea");
    if (textArea) {
      textArea.addEventListener("paste", handlePaste);
    }

    return () => {
      if (textArea) {
        textArea.removeEventListener("paste", handlePaste);
      }
    };
  }, []);

  useEffect(() => {
    if (isPrysmView) {
      setShowFollowups(false);
      return;
    }

    if (appStateContext?.state?.PrivacyFollowups?.length > 0) {
      setShowFollowups(true);
    }
  }, [appStateContext?.state?.PrivacyFollowups, isPrysmView]);

  const followUps = isPrysmView ? [] : appStateContext?.state?.PrivacyFollowups ?? [];
  const MicOnSVG = () => (
    <svg
      stroke="currentColor"
      fill="currentColor"
      stroke-width="0"
      viewBox="0 0 384 512"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M192 0C139 0 96 43 96 96l0 160c0 53 43 96 96 96s96-43 96-96l0-160c0-53-43-96-96-96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-33.6c85.8-11.7 152-85.3 152-174.4l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-40z"
        fill="#676767"
      ></path>
    </svg>
  );

  const MicOffSVG = () => (
    <svg
      stroke="currentColor"
      fill="currentColor"
      stroke-width="0"
      viewBox="0 0 384 512"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M192 0C139 0 96 43 96 96l0 160c0 53 43 96 96 96s96-43 96-96l0-160c0-53-43-96-96-96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-33.6c85.8-11.7 152-85.3 152-174.4l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-40z"
        fill="#fff"
      ></path>
    </svg>
  );
  const handleHomeClick = () => {
    appStateContext?.dispatch({ type: "RESET_APP" });

    appStateContext?.dispatch({ type: "RESET_MODEL" });

    appStateContext?.dispatch({
      type: "DROPDOWN_ITEM",
      payload: "MultiModel",
    });

    if (onNewChat) {
      onNewChat();
    }
  };

  return (
    <>
      {/* {showFollowups && followUps.length > 0 && (
      <div className={styles.followupSuggestions}>
        {followUps.map((followup: string, index: number) => (
          <button
            key={index}
            onClick={() => {
              setQuestion(followup);
              setShowFollowups(false);
            }}
            className={styles.followupButton}
            type="button"
          >
            {followup}
          </button>
        ))}
      </div>
    )} */}
    
      <Stack
        horizontal
        // style={{
        //   height: pastedImage ? "5.75rem" : "6rem",
        //   marginTop: pastedImage ? "-0.9375rem" : "0rem",
        // }}
        className={styles.questionInputContainer}
      >
        <div className="chatInput_TextImg">
          {pastedImage && (
            <div className="imagepreview">
              <>
                <img src={pastedImage} alt="Pasted Screenshot" />
                <button
                  type="button"
                  onClick={handleCancelFile}
                  className="cancelFileButton"
                  title="Remove file"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="1rem"
                    height="1rem"
                    fill="#ff0000"
                  >
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                  </svg>
                </button>
              </>
            </div>
          )}

          <div className="loader-test">
            {loading ? (
              <div className={styles.loader}></div>
            ) : (
              selectedFile &&
              !pastedImage && (
                <div className={styles.filePreviewContainer}>
                  <div className={styles.fileIcon}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 36 36"
                      fill="none"
                      className="h-8 w-8 flex-shrink-0"
                      width="24"
                      height="24"
                    >
                      <rect
                        width="36"
                        height="36"
                        rx="6"
                        fill="rgb(219, 33, 40)"
                      />
                      <path
                        d="M19.6663 9.66663H12.9997C12.5576 9.66663 12.1337 9.84222 11.8212 10.1548C11.5086 10.4673 11.333 10.8913 11.333 11.3333V24.6666C11.333 25.1087 11.5086 25.5326 11.8212 25.8451C12.1337 26.1577 12.5576 26.3333 12.9997 26.3333H22.9997C23.4417 26.3333 23.8656 26.1577 24.1782 25.8451C24.4907 25.5326 24.6663 25.1087 24.6663 24.6666V14.6666L19.6663 9.66663Z"
                        stroke="white"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M19.667 9.66663V14.6666H24.667"
                        stroke="white"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M21.3337 18.8334H14.667"
                        stroke="white"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M21.3337 22.1666H14.667"
                        stroke="white"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M16.3337 15.5H15.5003H14.667"
                        stroke="white"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <button
                    type="button"
                    onClick={handleCancelFile}
                    className={styles.cancelFileButton}
                    title="Remove file"
                    style={{
                      cursor: "pointer",
                      outline: "none",
                      position: "absolute",
                      bottom: "1.625rem",
                      left: "2rem",
                      background: "#fff",
                      border: ".0625rem solid #d4d4d4",
                      borderRadius: "1.5rem",
                      width: "1.5rem",
                      height: "1.5rem",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: " center",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="1rem"
                      height="1rem"
                      fill="currentColor"
                    >
                      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                    </svg>
                  </button>
                </div>
              )
            )}
          </div>

          <textarea
            className={styles.questionInputTextArea}
            placeholder={placeholder}
            value={question}
            onChange={onQuestionChange}
            onKeyDown={onEnterPress}
            onFocus={() =>
              appStateContext?.dispatch({
                type: "SET_TEXTAREA_FOCUS",
                payload: true,
              })
            }
            onBlur={() =>
              appStateContext?.dispatch({
                type: "SET_TEXTAREA_FOCUS",
                payload: false,
              })
            }
            style={{
              resize: "none",
              border: "none",
              backgroundColor: "var(--background-chattextbox-bold)",
            }}
          />
          {fileValidationError && (
            <div
              style={{
                color: "#b42318",
                fontSize: ".75rem",
                marginTop: ".375rem",
              }}
            >
              {fileValidationError}
            </div>
          )}
        </div>
        <div className="chatInputActions">
          <div className="chatInputActionsInnerWrapper">
            {/* <button
              className={styles.SendAttachment}
              type="button"
              data-tooltip-id="chatHome"
              onClick={handleHomeClick}
            >
              <i style={{ marginRight: "0rem" }}>
                <svg
                  stroke="currentColor"
                  fill="none"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  width="24"
                  height="24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className={styles.homeFill}
                    d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
                  ></path>
                  <polyline points="9 22 9 12 15 12 15 22"></polyline>
                </svg>
              </i>
            </button>
            <ReactTooltip
              className={styles.customTooltip}
              id="chatHome"
              place="top"
              content="Home"
            /> */}
            <button
              type="button"
              className={`${styles.SendAttachment} ${
                isClicked ? styles.deactive : ""
              }`}
              data-tooltip-id="sendAttachment"
              onClick={handleMenuOpen}
              // style={{
              //   cursor: "pointer",
              //   border: "none",
              //   background: "none",
              //   outline: "none",
              // }}
              disabled={Boolean(pastedImage) || isClicked}
            >
              <i style={{ marginRight: "0rem" }}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-label=""
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9 7C9 4.23858 11.2386 2 14 2C16.7614 2 19 4.23858 19 7V15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15V9C5 8.44772 5.44772 8 6 8C6.55228 8 7 8.44772 7 9V15C7 17.7614 9.23858 20 12 20C14.7614 20 17 17.7614 17 15V7C17 5.34315 15.6569 4 14 4C12.3431 4 11 5.34315 11 7V15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V9C13 8.44772 13.4477 8 14 8C14.5523 8 15 8.44772 15 9V15C15 16.6569 13.6569 18 12 18C10.3431 18 9 16.6569 9 15V7Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </i>
            </button>
            <ReactTooltip
              className={styles.customTooltip}
              id="sendAttachment"
              place="top"
              // content="Send Attachment (DOC, XLS, PDF)"
              content="Attachment (DOC, XLS, PDF)"
            />
            <button
              type="button"
              className={` ${styles.webSearch} ${
                isClicked ? styles.active : ""
              }`}
              data-tooltip-id="webSearch"
              onClick={handleSearch}
              // style={{
              //   cursor: "pointer",
              //   border: "none",
              //   background: "none",
              //   outline: "none",
              // }}
            >
              <i>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM11.9851 4.00291C11.9933 4.00046 11.9982 4.00006 11.9996 4C12.001 4.00006 12.0067 4.00046 12.0149 4.00291C12.0256 4.00615 12.047 4.01416 12.079 4.03356C12.2092 4.11248 12.4258 4.32444 12.675 4.77696C12.9161 5.21453 13.1479 5.8046 13.3486 6.53263C13.6852 7.75315 13.9156 9.29169 13.981 11H10.019C10.0844 9.29169 10.3148 7.75315 10.6514 6.53263C10.8521 5.8046 11.0839 5.21453 11.325 4.77696C11.5742 4.32444 11.7908 4.11248 11.921 4.03356C11.953 4.01416 11.9744 4.00615 11.9851 4.00291ZM8.01766 11C8.08396 9.13314 8.33431 7.41167 8.72334 6.00094C8.87366 5.45584 9.04762 4.94639 9.24523 4.48694C6.48462 5.49946 4.43722 7.9901 4.06189 11H8.01766ZM4.06189 13H8.01766C8.09487 15.1737 8.42177 17.1555 8.93 18.6802C9.02641 18.9694 9.13134 19.2483 9.24522 19.5131C6.48461 18.5005 4.43722 16.0099 4.06189 13ZM10.019 13H13.981C13.9045 14.9972 13.6027 16.7574 13.1726 18.0477C12.9206 18.8038 12.6425 19.3436 12.3823 19.6737C12.2545 19.8359 12.1506 19.9225 12.0814 19.9649C12.0485 19.9852 12.0264 19.9935 12.0153 19.9969C12.0049 20.0001 11.9999 20 11.9999 20C11.9999 20 11.9948 20 11.9847 19.9969C11.9736 19.9935 11.9515 19.9852 11.9186 19.9649C11.8494 19.9225 11.7455 19.8359 11.6177 19.6737C11.3575 19.3436 11.0794 18.8038 10.8274 18.0477C10.3973 16.7574 10.0955 14.9972 10.019 13ZM15.9823 13C15.9051 15.1737 15.5782 17.1555 15.07 18.6802C14.9736 18.9694 14.8687 19.2483 14.7548 19.5131C17.5154 18.5005 19.5628 16.0099 19.9381 13H15.9823ZM19.9381 11C19.5628 7.99009 17.5154 5.49946 14.7548 4.48694C14.9524 4.94639 15.1263 5.45584 15.2767 6.00094C15.6657 7.41167 15.916 9.13314 15.9823 11H19.9381Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </i>{" "}
              <span className={styles.text_span}>Search</span>
            </button>
            <ReactTooltip
              className={styles.customTooltip}
              id="webSearch"
              place="top"
              content="Web Search"
            />           
          </div>

          <div className="qi_ActionWrapper">
            <div>
              <MicButton
                voiceStatus={voiceStatus}
                onClick={handleRealtimeVoiceClick}
                disabled={!isVoiceEnabledForSelectedApp}
                tooltipTextOverride={voiceTooltipText}
              />
            </div>
             <ReactTooltip
              className={styles.customTooltip}
              id="voiceSearch"
              place="top"
              content="Voice Search"
            />

            {/* <button
              type="button"
              className={`${styles.questionMicButton} ${
                listening ? styles.listening : ""
              }`}
              data-tooltip-id="voiceMode"
              onClick={
                isRealtimeVoiceActive ? undefined : startListening
              }
              aria-disabled={isRealtimeVoiceActive}
              disabled={isRealtimeVoiceActive}
            >
              <i>{listening || micStatus ? <MicOffSVG /> : <MicOnSVG />}</i>
             
            </button> */}

           

            {/* <ReactTooltip
              className={styles.customTooltip}
              id="voiceMode"
              place="top"
              content="Dictate"
            /> */}

            {/* <button
              type="button"
              className={styles.regenrateBtn}
              onClick={regenrateHandle}
              title="Regenerate last query response"
              data-tooltip-id="regenrate"
              disabled={!sendQuestionDisabled || !isLoading}
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path d="M256 388c-72.597 0-132-59.405-132-132 0-72.601 59.403-132 132-132 36.3 0 69.299 15.4 92.406 39.601L278 234h154V80l-51.698 51.702C348.406 99.798 304.406 80 256 80c-96.797 0-176 79.203-176 176s78.094 176 176 176c81.045 0 148.287-54.134 169.401-128H378.85c-18.745 49.561-67.138 84-122.85 84z" />
              </svg>
            </button>
            <ReactTooltip
              className={styles.customTooltip}
              id="regenrate"
              place="top"
              content="Regenerate last query response"
            /> */}
            {/* {appStateContext?.state.isCosmosDBAvailable?.status !==
            CosmosDBStatus.NotConfigured ? ( */}
            <button
              data-tooltip-id="sendChat"
              className={`${styles.questionInputSendButtonContainer} ${
                sendQuestionDisabled
                  ? styles.send_btn_disable
                  : styles.send_btn_enable
              }`}
              aria-label="Ask question button"
              onClick={() => sendQuestion()}
              onKeyDown={(e) =>
                e.key === "Enter" || e.key === " " ? sendQuestion() : null
              }
            >
              {sendQuestionDisabled ? (
                <i>
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    stroke-width="0"
                    viewBox="0 0 16 16"
                    height="16"
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471z"></path>
                  </svg>
                </i>
              ) : (
                <i>
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    stroke-width="0"
                    viewBox="0 0 16 16"
                    height="16"
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471z"></path>
                  </svg>
                </i>
              )}
            </button>

            {/* ) : <div className={styles.chatLoader}></div>
             
             }  */}
          </div>
          <ReactTooltip
            className={styles.customTooltip}
            id="sendChat"
            place="top"
            content="Send"
          />
          <Menu
            anchorEl={menuAnchorEl}
            open={Boolean(menuAnchorEl)}
            onClose={handleMenuClose}
            className={styles.attachMenu}
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            PaperProps={{
              style: {
                borderRadius: ".5rem",
                boxShadow: "0rem .25rem 1.25rem rgba(0, 0, 0, 0.1)",
                padding: "0rem",
                minWidth: "14.5rem",
                border: "0",
                background: "transparent",
                overflow: "hidden",
              },
            }}
          >
            <MenuItem
              style={{
                borderRadius: "2.5rem",
                background: "transparent",
                padding: "0",
              }}
            >
              <div className={styles.upload_element}>
                <i>
                  <svg
                    stroke="currentColor"
                    fill="none"
                    stroke-width="2"
                    viewBox="0 0 24 24"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    height="24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                    <polyline points="17 8 12 3 7 8"></polyline>
                    <line x1="12" x2="12" y1="3" y2="15"></line>
                  </svg>
                </i>
                {/* <img
                src={ImpIcon}
                alt="Device Icon"
                style={{ width: "1.5rem", marginRight: ".625rem" }}
              /> */}
                <label style={{ cursor: "pointer" }}>
                  {" "}
                  Upload from this device
                  <input
                    type="file"
                    style={{ display: "none" }}
                    accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,.csv,.png,.jpg,.jpeg,.webp,.gif,.bmp"
                    onChange={handleFileSelect}
                  />
                </label>
              </div>
            </MenuItem>

            {/* <MenuItem
  disabled 
    style={{
      display: "flex",
      alignItems: "center",
      padding: ".625rem 1.25rem",
      fontSize: ".875rem",
      color: "#333",
    }}
  >
    <img
      src={DriveIcon}
      alt="Drive Icon"
      style={{ width: "1.5rem", marginRight: ".625rem" }}
    />
    <label style={{ cursor: "pointer" }}>
      Upload from Drive
      <input
        type="file"
        style={{ display: "none" }}
        onChange={handleFileSelect}
      />
    </label>
  </MenuItem> */}
          </Menu>
          <div className={styles.questionInputBottomBorder} />
        </div>
      </Stack>

    </>
  );
};



